import React, {Fragment } from 'react';
import { 
    useQuery, 
    Loading, 
    Error,
    TextInput,
    DateInput,
    ArrayInput,
    SimpleFormIterator,
    BooleanInput,
    
 } from 'react-admin';

import HtmlToReact from 'html-to-react'


var HtmlToReactParser = HtmlToReact.Parser;
var htmlToReactParser = new HtmlToReactParser();


const Heading=({data})=>{
    return (<h3>{data}</h3>)
}

  const classes = {
    root: { alignItems: 'flex-start'},
    trainer_init: {  width: '2em' },
    trainee_init: {  width: '2em' },
    booth: {  width: '2em' },
    date: {  
        width: '1em',
        display: 'inline',
        margin: '2px',
        padding: '2px',
    },
    date_prof: {  width: '7em' },

    inlineBlock: {
        display: 'inline',
        margin: '2px',
        padding: '2px',
    },
    cell30per :{
        width:"30%", 
        cellSpacing:"10",
    },
    hidden : {
        display: 'none',
        visibility: 'hidden',
    }
};

const Contents =({data})=>{
    // console.log(data)
     var contents  = [];
     let i=0
     if(data){
       try{
         contents =JSON.parse(data) 
       } catch(e) {
         //console.log(e)
         contents = data;
       };
     }
     
     return(
       <>
       {
        contents && contents.map((item, index) =>(
         <tr  key={index}>
             <td>{item['procedure']} <TextInput source={`proc_${++i}`} defaultValue={item['procedure']}  style={{ display: 'none', visibility: 'hidden'}} /></td>
             <td><DateInput source={`read_date_${i}`}    label="" locales="en-us"  locales="en-us"/></td>
             <td><TextInput source={`emp_init_${i}`} label="" /></td>
             <td><DateInput source={`emp_init_date_${i}`}    label="" locales="en-us"  locales="en-us"/></td>
        </tr>
        )
        
       )}
       <TextInput source={`det_count`} defaultValue={i} label='' style={{ display: 'none', visibility: 'hidden'}} />
       
      </>
     )
 }


const ContentCreate = (props) =>{
  //  console.log(props)
    let uid = (props && props.uid)? props.uid :  null;

    const { data, loading, error } = useQuery({ 
        type: 'getOne',
        resource: 'recertuserslist',
        payload:  {id: uid}
    });

    if (loading) return <Loading />;
    if (error) return <Error />;
    if (!data) return null;
    //console.log(data)
    return (
        <Fragment>
        <table style={{width:"99%", fontSize: "12px"}}>
            <tbody>
            <tr>
                <td colSpan="4">
                    <table  border ="1" cellSpacing="0" style={{width:"100%", textAlign: "center"}}>
                    <tbody>
                    <tr>
                        <td>
                            <table  border ="0" style={{width:"100%", textAlign: "center"}}>
                            <tbody>
                            <tr>
                                <td style={{fontSize: "9px"}}> 
                                    Annual Recertification Form
                                </td>
                            </tr>
                            <tr>
                                <td ><Heading  data={data && data.name} /><TextInput source='name' defaultValue={data && data.name}   style={{ display: 'none', visibility: 'hidden'}} /></td>
                            </tr>
                           
                            </tbody>
                            </table>
                        </td>                  
                    </tr>
                    </tbody>
                    </table>
                </td>
            </tr>
            <tr><td  colSpan="4">&nbsp;</td></tr>
            <tr>
                <td>Employee Name:</td>
                <td  colSpan="3"><TextInput source="emp_name" label="" defaultValue={data && data.full_name}/></td>
            </tr>
            <tr>
                <td>Employee Titile:</td>
                <td  colSpan="3"><TextInput source="emp_title" label="" defaultValue={data && data.title}/></td>
            </tr>
            <tr><td  colSpan="4">&nbsp;</td></tr>
            <tr>
                <td colSpan="4">
                    <table border="1" cellSpacing="0" style={{ width:"100%"}}>
                        <tbody>
                            <tr>
                                <th style={{backgroundColor: "silver", fontWeight: "bold", width:"60%", textAlign: "center"}}>Procedure</th>
                                <th style={{backgroundColor: "silver", fontWeight: "bold", width:"15%", textAlign: "center"}}>Date of Reading</th>
                                <th style={{backgroundColor: "silver", fontWeight: "bold", width:"10%", textAlign: "center"}}>Employee Initial</th>
                                <th style={{backgroundColor: "silver", fontWeight: "bold", width:"15%", textAlign: "center"}}>Date</th>
                            </tr>
                            <Contents data={data && data.content} label="" />
                        </tbody>
                    </table>
            
                </td>
            </tr>
            <tr><td  colSpan="4">&nbsp;</td></tr>
            {(data && data.isphy_sub )?(
            <Fragment>
            <tr>
                <td  colSpan="4">
                <table border="1" cellSpacing="0" style={{ width:"100%"}}>
                <tbody>
                    <tr>
                        <td>
                            <table style={{ width:"100%"}}>
                            <tbody>
                                <tr>
                                    <td colSpan="4"><b>For Physician Substitute ONLY</b></td>
                                </tr>
                                <tr>
                                    <td colSpan="2">Physical Examination performed in presence of CMD on Date:</td>
                                    <td colSpan="2"><DateInput source="cmd_date" label="" locales="en-us" /></td>
                                </tr>
                                <tr>
                                    <td colSpan="4">
                                    <u>CMD Comments:</u>
                                    <TextInput source="cmd_comments" label="" multiline fullWidth />
                                    </td>
                                </tr>
                                <tr>
                                    <td>Center Medical Director Signature:</td>
                                    <td><TextInput source="cmd_sign" label=""  /></td>
                                    <td>&nbsp;Date:</td>
                                    <td><DateInput source="cmd_sign_date" label="" locales="en-us" /></td>
                                </tr>
                            </tbody>
                            </table>
                        </td>
                    </tr>
                </tbody>
                </table>
                </td>
            </tr>
            <tr><td  colSpan="4">&nbsp;</td></tr>
            </Fragment>): null
            }
            <BooleanInput source="isphy_sub" label="" defaultValue={data && data.isphy_sub} style={{ display: 'none', visibility: 'hidden'}}/>
            <tr>
                <td  colSpan="2">{data && data.exam_desc}<TextInput source="exam_desc" label="" defaultValue={data && data.exam_desc}  style={{ display: 'none', visibility: 'hidden'}}/>&nbsp;&nbsp;&nbsp;<b>Pass/Fail:</b></td>
                <td colSpan="2"><BooleanInput source="ispass" label="" defaultChecked={data && data.ispass}/></td>
            </tr>
            <tr>
                <td colSpan="4">
                    <table width="100%">
                        <tbody>
                            <tr>
                                <td>Employee Name</td><td><TextInput source="emp_name" label="" defaultValue={data && data.full_name}/></td>
                                <td>Signature</td><td><TextInput source="emp_sign" label="" /></td>
                                <td>Date</td><td><DateInput source='emp_sign_date' label="" locales="en-us"/></td>
                            </tr>
                            <tr>
                                <td>Management/QA review</td><td><TextInput source="qa_review" label="" /></td>
                                <td>Signature</td><td><TextInput source="qa_sign" label="" /></td>
                                <td>Date</td><td><DateInput source='qa_sign_date'    label="" locales="en-us"  locales="en-us"/></td>
                            </tr>
                        </tbody>
                    </table>
                </td>
            </tr>
           
            </tbody>
        </table>
        </Fragment>
        )
}

export default ContentCreate
